"use client";

import { AppDownload } from "@faire/retailer-visitor-shared/components/MobileAppPromoBanner/AppDownload";
import { DesktopAppDownloadPhoneInputForm } from "@faire/retailer-visitor-shared/components/MobileAppPromoBanner/AppDownloadPromoBanner";
import { Spacer } from "@faire/web--source/slate/spacing";
import { ResponsiveContentV2 } from "@faire/web--source/ui/ResponsiveContentV2";
import { IBannerComponent } from "@faire/web-api--source/indigofair/data/IBannerComponent";
import React from "react";

export const SDUIBannerCTARenderer: React.FC<{
  bannerComponent: IBannerComponent;
}> = ({ bannerComponent }) => {
  const CTAElementComponent = getCTAElementRenderer(bannerComponent);

  if (CTAElementComponent === undefined) {
    return null;
  }

  return (
    <>
      <Spacer height="4x" />
      <CTAElementComponent />
    </>
  );
};

const getCTAElementRenderer = (bannerElement: IBannerComponent) => {
  if (bannerElement.app_download_phone_input_c_t_a_element) {
    return SDUIBannerAppDownloadPhoneInputCTA;
  }

  return undefined;
};

const SDUIBannerAppDownloadPhoneInputCTA = () => {
  return (
    <ResponsiveContentV2
      tabletAndBelow={<AppDownload noModal />}
      desktopAndAbove={<DesktopAppDownloadPhoneInputForm />}
    />
  );
};
